import { render, staticRenderFns } from "./ChallengeManagement.vue?vue&type=template&id=e72d11cc&scoped=true"
import script from "./ChallengeManagement.vue?vue&type=script&lang=js"
export * from "./ChallengeManagement.vue?vue&type=script&lang=js"
import style0 from "./ChallengeManagement.vue?vue&type=style&index=0&id=e72d11cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72d11cc",
  null
  
)

export default component.exports